import './styles/page-title.scss'

interface Props {
    title: string
}

function PageTitle({title}: Props) {
    return (
        <h2 className="page__title">
            { title }
        </h2>
    )
}

export default PageTitle